import { SeoMetaData } from '@cms-max/cms-browser-api-client'

export const ConnectedAppsSeoMetaData: SeoMetaData[] = [
  {
    path: '/connected-apps',
    seo: {
      en: {
        title: 'My connected apps | Medicare',
        description: ''
      },
      es: {
        title: 'Mis aplicaciones conectadas | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  component: 'Connected Apps',
  ...seoMetaData
}))
